module.exports = __webpack_public_path__ + "static/media/9.0ea59faf.png";